import { Card, CardBody, Col, ListInlineItem, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import {  HorizontalTimelines, Href, ReadMore } from "../../../../Constant";
import { Btn, H5, P } from "../../../../AbstractElements";
import { HORIZONTAL_TIMELINE, HORIZONTAL_TIMELINE_DATA } from "../../../../Data/Bonus Ui/Timeline";
import { HorizontalTimelineProp } from "../../../../Type/BonusUi";

const HorizontalTimeline = () => {
  return (
    <Col xxl="8" xl="7" className="box-col-12">
      <Card>
        <CommonCardHeader title={HorizontalTimelines} span={HORIZONTAL_TIMELINE} />
        <CardBody>
          {HORIZONTAL_TIMELINE_DATA.map(({ mainClass, child }: HorizontalTimelineProp, index) => (
            <Row className={`list-inline events timeline-list ${mainClass}`} key={index}>
              {child.map(({ colClass, color, date, header, paragraph, verticalLine1, verticalLine2 }, index) => (
                <Col xxl="4" className={colClass} key={index}>
                  <div>
                    {verticalLine2 && <div className={verticalLine2}></div>}
                    <ListInlineItem className="event-list">
                      <div className="px-4">
                        <div className={`event-date alert-light-${color} txt-${color}`}>{date}</div>
                        <H5>{header} </H5>
                        <P className="text-muted">{paragraph}</P>
                        <div className="read-more-btn"><Btn color="primary" tag="a" href={Href} className="px-3">{ReadMore}</Btn></div>
                      </div>
                    </ListInlineItem>
                    {verticalLine1 && <div className={verticalLine1}></div>}
                  </div>
                </Col>
              ))}
            </Row>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default HorizontalTimeline;
